import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter, FilterField } from "~/features/filter";

type Translate = (key: string) => string;

interface LogsFilterProps {
  fields: (t: Translate) => FilterField[];
}

const LogsFilter = ({ fields: fieldsFn }: LogsFilterProps) => {
  const { t } = useTranslation();

  const fields = useMemo(() => fieldsFn(t), [fieldsFn, t]);

  return <Filter.Root fields={fields} alwaysShow columns={4} />;
};

export default LogsFilter;
